module.exports = __webpack_public_path__ + "img/antes_despues_326.cdbf4859.png";